// @flow
import Payment from "@kiwicom/frontend-app/scripts/containers/mutable/Payment"

export type PaymentInput = {
  original_price: number,
  credits_payment: number,
  card_payment: number,
  original_currency: string,
  price: number,
}

export default function({
  original_price,
  credits_payment,
  card_payment,
  original_currency,
  price,
}: PaymentInput): Payment {
  return new Payment({
    amount: original_price || credits_payment,
    credits: credits_payment,
    cardPaymentAmount: card_payment,
    currency: original_currency && original_currency.toLowerCase(),
    amountInEur: price,
  })
}
